import { IconButton, InputAdornment, Stack, styled, Typography } from '@mui/material';
import { LayoutNoAuth } from 'app/components/templates/LayoutNoAuth';
import { StyledParams } from 'types/common';
import { useInjection } from './hook';
import { InputText } from 'app/components/elements/InputText';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import theme from 'styles/theme';
import { useSystemInfo } from 'contexts/systemInfo';

export const ResetPasswordPage = () => {
  const { systemInfo } = useSystemInfo();

  const {
    handleSubmitForm,
    handleSubmit,
    register,
    errors,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword
  } = useInjection();
  return (
    <LayoutNoAuth>
      <Wrapper>
        <Stack
          pt={{ xs: 4, md: 8.375 }}
          pb={3.5}
          width={'100%'}
          alignItems={'center'}
          minHeight={'100vh'}>
          <Stack
            px={{ xs: 3.125, sm: 0 }}
            mt={3}
            width={'100%'}
            maxWidth={{ xs: 'unset', sm: 402 }}>
            <Stack width={'100%'} alignItems={'center'} gap={{ xs: 3, md: 7.25 }} mb={6.25}>
              {systemInfo?.logoUrl && <img alt={'logo'} width={96} src={systemInfo?.logoUrl} />}
              <Stack gap={2}>
                <TextTitleStyled>Reset Password</TextTitleStyled>
                <TextDescStyled>Enter a new password below to reset your account. </TextDescStyled>
              </Stack>
            </Stack>
            <form onSubmit={handleSubmit(handleSubmitForm)}>
              <Stack gap={{ xs: 3, md: 8 }}>
                <Stack gap={{ xs: 1, md: 2.5 }}>
                  <Stack gap={1} mb={2}>
                    <InputText
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? (
                              <Visibility sx={{ color: theme.colors.base }} />
                            ) : (
                              <VisibilityOff sx={{ color: theme.colors.base }} />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      placeholder={'New Password'}
                      inputError={errors.password?.message}
                      inputProps={{
                        ...register('password'),
                        type: showPassword ? 'text' : 'password'
                      }}
                    />
                  </Stack>
                  <Stack gap={1} mb={2}>
                    <InputText
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                            {showConfirmPassword ? (
                              <Visibility sx={{ color: theme.colors.base }} />
                            ) : (
                              <VisibilityOff sx={{ color: theme.colors.base }} />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                      placeholder={'Confirm New Password'}
                      inputError={errors.password?.message}
                      inputProps={{
                        ...register('confirmPassword'),
                        type: showConfirmPassword ? 'text' : 'password'
                      }}
                    />
                  </Stack>
                </Stack>
                <ButtonCustom type={'submit'} label={'Send'} />
              </Stack>
            </form>
          </Stack>
        </Stack>
      </Wrapper>
    </LayoutNoAuth>
  );
};

const Wrapper = styled(Stack)(() => ({
  height: '100vh',
  overflowY: 'scroll'
}));
const TextTitleStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: '32px',
  fontWeight: '700',
  color: theme.colors.base,
  textAlign: 'center'
}));
const TextDescStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: '14px',
  fontWeight: '700',
  color: theme.colors.base,
  textAlign: 'center',
  width: 271
}));
